import Box from '@mui/material/Box';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../../util/apiClient';
import { deleteDroit, IDroit, setDescriptionEdit, setDroitsBySuousModule, setObjDroit, setOpenDialogDroit, setValueEdit } from './droitSlice';
import CommonListe from '../../../../components/Common/CommonListe';



const ListeDroit = () => {


    //redux
    const dispatch = useDispatch()
    const { droits,droitsBySuousModule } = useSelector((state: IReduxState) => state.droits);
    const { objSousModuleDroit } = useSelector((state: IReduxState) => state.sousModuleDroit);



    const deleteItem = async (item: IDroit) => {
        try {
            const apiPayload = { idDroit: item.idDroit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/supprimerdroit", apiPayload)
            if (res.status === 1) {
                dispatch(deleteDroit(res.data))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };



    const handleEditDialogOpen = (item: IDroit) => {
        dispatch(setOpenDialogDroit(true))
        dispatch(setObjDroit(item))
        dispatch(setValueEdit(item.libDroit))
        dispatch(setDescriptionEdit(item.descriptionDroit))
    }

    const getDroitsBySousModule = () => {
        dispatch(setDroitsBySuousModule(droits.filter((droit: IDroit) => droit.idSousModuleDroit === objSousModuleDroit.idSousModuleDroit)))
    }

    useEffect(() => {
        getDroitsBySousModule()
    }, [objSousModuleDroit, droits]);



    return (
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
            <CommonListe
                data={droitsBySuousModule}
                deleteItem={deleteItem}
                setItem={setObjDroit}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box>
    );
}

export default ListeDroit;
